// 生产环境地址
const configProduction = {
  backendBaseUrl: 'https://api.yi-insurance.cn', //后台地址
  appid: 'wx32b8cbbdff4b95fc', //微信签名
  platformCode: 'tangsengbao',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// uat环境地址
const configUat = {
  backendBaseUrl: 'https://api.tsbdev.top', //后台地址
  appid: 'wxe70ff1425a59f6df', //微信签名
  platformCode: 'JingsuanAI',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// 开发环境地址
const configDev = {
  backendBaseUrl: 'http://127.0.0.1:8000', //后台地址
  appid: 'wxe70ff1425a59f6df', //微信签名
  platformCode: 'JingsuanAI',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// protectionAngel环境地址
const configProtectionAngel = {
  backendBaseUrl: 'https://api.yj-insurance.com', //后台地址
  appid: 'wx17219742c0530d63', //微信签名
  platformCode: 'ProtectionAngel',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// wanqubaoxian环境地址
const configWanqu = {
  backendBaseUrl: 'https://api.yj-insurance.com', //后台地址
  appid: 'wx3c12494278a5d4d7', //微信签名
  platformCode: 'wanqubaoxian',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// wanquPolicy环境地址
const configWanquPolicy = {
  backendBaseUrl: 'https://api.yj-insurance.com', //后台地址
  appid: 'wxcb6a9be004ab8a4c', //微信签名
  platformCode: 'wanquPolicy',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
// tsbyanxuan环境地址
const configTsbyanxuan = {
  backendBaseUrl: 'https://api.yj-insurance.com', //后台地址
  appid: 'wx49a3eef96b2e7fb4', //微信签名
  platformCode: 'tsbyanxuan',
  reCaptchaKey: '6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte',
};
export const config = () => {
  if (process.env.NODE_ENV === 'production') {
    return configProduction;
  } else if (process.env.NODE_ENV === 'uat') {
    return configUat;
  } else if (process.env.NODE_ENV === 'protectionAngel') {
    return configProtectionAngel;
  } else if (process.env.NODE_ENV === 'wanqubaoxian') {
    return configWanqu;
  } else if (process.env.NODE_ENV === 'wanquPolicy') {
    return configWanquPolicy;
  } else if (process.env.NODE_ENV === 'tsbyanxuan') {
    return configTsbyanxuan;
  }
  return configDev;
};
